import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import TranslateIcon from '@mui/icons-material/Translate';
import { Navigation } from '@toolpad/core/AppProvider';

export const NAVIGATION: Navigation = [
  { segment: 'integrations', title: 'Wdrożenia', icon: <DescriptionIcon /> },
  { segment: 'translations', title: 'Tłumaczenia', icon: <TranslateIcon /> },
  { kind: 'divider' },
  { kind: 'header', title: 'Obsługa klienta' },
  { segment: 'support', title: 'Zgłoszenia i błędy', icon: <DescriptionIcon /> },
  { segment: 'credit-support', title: 'Wsparcie godzinowe', icon: <AccessTimeIcon /> },
  { segment: 'status-calls', title: 'Status calle', icon: <CalendarMonthIcon /> },
  { segment: 'support-slots', title: 'Terminy konsultacji', icon: <DescriptionIcon /> },

  { kind: 'divider' },
  {
    segment: 'cms',
    title: 'CMS',
    icon: <SettingsIcon />,
    children: [
      { segment: 'cms-feature-template', title: 'Feature template', icon: <DescriptionIcon /> },
    ]
  },
];
